
export default {
  name: "TabMenu",
  props: {
    id: {
      default: 'default',
      type: String,
    },
    margin: {
      default: '',
      type: String,
    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },

}
